import React, { useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'antd';
import Util from '../../../script/util';
import WebglVideo from '../../webglVideo/indexNew';

let svgaCarPlayer = null;
let svgaCarParser = null;
let webglCarPlayer = null;
const PropDetailsModal = ({ cRef }) => {
  const [visible, setVisible] = useState(false); // 是否显示弹窗
  const [detail, setDetail] = useState(null); // 详情

  useImperativeHandle(cRef, () => ({
    showModal: (data) => {
      if (data) {
        setDetail(data);
        setVisible(true);
      }
    },
  }));

  useEffect(() => {
    return () => {
      destroyPlay();
    };
  }, []);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (visible && detail) {
      setTimeout(async () => {
        if (detail?.effectPicPc?.indexOf('.svga') > -1) {
          svgaCarPlayer = new window.SVGA.Player('#car-effects-box');
          svgaCarParser = new window.SVGA.Parser('#car-effects-box');
          svgaCarParser.load(
            Util.transImgUrl(detail?.effectPicPc),
            (videoItem) => {
              svgaCarPlayer.loops = 0; // 循环播放
              svgaCarPlayer.setVideoItem(videoItem);
              svgaCarPlayer.startAnimation();
              svgaCarPlayer.clearsAfterStop = true;
            }
          );
        } else if (detail?.effectPicPc?.indexOf('.mp4') > -1) {
          const dom = document.querySelector('#car-effects-box');
          webglCarPlayer = await WebglVideo({
            container: dom,
            src: Util.transImgUrl(detail?.effectPicPc),
            loop: true,
            effects: {
              dingwei: {
                text: '',
              },
            },
          });
        }
      }, 300);
    } else {
      destroyPlay();
    }
  }, [visible]);
  // 销毁播放
  const destroyPlay = () => {
    // 销毁座驾SVGA
    if (svgaCarPlayer) {
      svgaCarPlayer.stopAnimation();
      svgaCarPlayer.clear();
      svgaCarPlayer.clearDynamicObjects();
    }
    // 销毁座驾WEBGL
    if (webglCarPlayer) {
      webglCarPlayer.stop();
    }
    let dom = document.querySelector('#car-effects-box');
    if (dom) {
      dom.innerHTML = '';
    }
  };

  // 隐藏弹窗
  const hideModal = () => {
    setVisible(false);
    setTimeout(() => {
      setDetail(null);
    }, 200);
  };

  return (
    <Modal
      open={visible}
      title={null}
      width={1130}
      height={660}
      wrapClassName="atlas-details-modal car"
      footer={null}
      closable={false}
      centered
      maskClosable={false}
    >
      <div className="car-effect-box" id="car-effects-box"></div>
      <div className="icon-close" onClick={hideModal} />
    </Modal>
  );
};

export default PropDetailsModal;
